import { createContext, useState } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);

  const addToCart = (item) => {
    setCartItems((prev) => [...prev, item]);
  };

 const addToWishlist = (item) => {
  setWishlistItems((prev) => {
    const exists = prev.find((i) => i.id === item.id);
    if (exists) {
      return prev.filter((i) => i.id !== item.id); // remove if exists
    } else {
      return [...prev, item]; // otherwise add
    }
  });
};


  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((i) => i.id !== id));
  };

  const removeFromWishlist = (id) => {
    setWishlistItems((prev) => prev.filter((i) => i.id !== id));
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        wishlistItems,
        addToCart,
        addToWishlist,
        removeFromCart,
        removeFromWishlist
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
